/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card, FormControl, InputLabel, Checkbox, Grid, FormHelperText
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import { endOfMonth } from 'date-fns';

var screenCode = "NETBENEFITOFFCCPURCHASESREPORT"

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function NetBenefitOfFCCPurchasesReport(props) {
    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const onKeyDown = (e) => {
        e.preventDefault();
    };
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    // const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [purchasePrice, setPurchasePrice] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [NetBenefitOfFCCDetails, setnetBenefitOfFCCDetails] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        cropCategoryID: 0,
        cropID: 0,
        fromDate: new Date(fromDate).toISOString(),
        // toDate: new Date(toDate).toISOString(),
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const NetBenefitOfFCCPurchasesSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number()
            .min(1, 'Please select a fresh collection center')
            .required('Please select a fresh collection center'),
        cropCategoryID: Yup.array()
            .min(1, 'Please select at least one product category')
            .required('Please select at least one product category'),
        cropID: Yup.array()
            .min(1, 'Please select at least one product')
            .required('Please select at least one product')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: '',
        operationEntity: '',
        cropCategory: '',
        crop: '',
        // toDate: '',
        fromDate: ''
    });
    const [total, setTotalRow] = useState({
        netAmount: 0,
        fccBuyingPrice: 0,
        regionalMarketWS: 0,
        fccPurchaseValue: 0,
        purchaseFromECValue: 0,
        valueSaving: 0,
        saving: 0
    });

    const [mtdDetails, setMtdDetails] = useState({
        fccPurchaseValue: 0,
        purchaseFromECValue: 0,
        valueSaving: 0,
        saving: 0
    });

    const [ytdDetails, setYtdDetails] = useState({
        fccPurchaseValue: 0,
        purchaseFromECValue: 0,
        toDateFCCPurchaseValue: 0,
        toDatepurchaseFromECValue: 0,
        valueSaving: 0,
        saving: 0
    });

    const [ytdTotalDetails, setYtdTotalDetails] = useState({
        ytdFCCPurchasingValue: 0,
        ytdECPurchaseValue: 0,
        ytdValueSaving: 0,
        ytdsaving: 0
    });
    const [endofMonth, setEndofMonth] = useState(endOfMonth(new Date()));
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions,
            fromDate: formData.fromDate,
            // toDate: formData.toDate
        },
        validationSchema: NetBenefitOfFCCPurchasesSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'NETBENEFITOFFCCPURCHASESREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: 0
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: parseInt(values.operationEntityID),
            cropID: selectedProductOptions.map(x => x).join(',').toString(),
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            // toDate: moment(toDate).format('YYYY-MM-DD')
        }
        var ress = await services.GetNetBenefitOfFCCPurchasesReportDetails(model)
        const res = ress.details;
        const resOne = ress.mtdDetails;
        const resTwo = ress.ytdDetails;

        const mtdFCCPurchaseValue = resOne[0]?.fccPurchaseValue
        const mtdPurchaseFromECValue = resOne[0]?.purchaseFromECValue
        const mtdValueSaving = (mtdPurchaseFromECValue - mtdFCCPurchaseValue)
        const mtdSaving = mtdPurchaseFromECValue == 0 ? 0 : (mtdValueSaving / mtdPurchaseFromECValue) * 100

        const ytdFCCPurchaseValue = resTwo[0]?.fccPurchaseValue
        const ytdPurchaseFromECValue = resTwo[0]?.purchaseFromECValue
        const toDateytdFCCPurchaseValue = resTwo[0]?.toDateFCCPurchaseValue
        const toDateytdPurchaseFromECValue = resTwo[0]?.toDatePurchaseFromECValue
        const ytdValueSaving = (ytdPurchaseFromECValue - ytdFCCPurchaseValue)
        const ytdSaving = ytdPurchaseFromECValue == 0 ? 0 : (ytdValueSaving / ytdPurchaseFromECValue) * 100
        var result1 = [];
        res.forEach(x => {
            var duplicateDate1 = result1.find(y => y.productID === x.productID && y.marketCode === x.marketCode && y.createdDate === x.createdDate);

            if (duplicateDate1) {
                x.purchaseFromECValue = parseInt(0)
            }
            else {
                x.purchaseFromECValue = x.purchaseFromECValue
                result1.push(x)
            }
            x.actualfccPurchaseValue = x.netAmount * x.fccPurchaseValue
        });

        var result = [];

        res.forEach(x => {
            var duplicateDate = result.find(y => y.productID === x.productID);

            if (duplicateDate) {
                duplicateDate.productName = x.productName;
                duplicateDate.productID = x.productID;
                duplicateDate.netAmount = duplicateDate.netAmount + x.netAmount;
                duplicateDate.fccBuyingPrice = duplicateDate.fccBuyingPrice + x.fccPurchaseValue;
                duplicateDate.actualfccPurchaseValue += x.actualfccPurchaseValue;
                duplicateDate.regionalMarketWS += x.purchaseFromECValue;
            }
            else {
                result.push({
                    productName: x.productName,
                    productID: x.productID,
                    netAmount: x.netAmount,
                    fccBuyingPrice: x.fccPurchaseValue,
                    actualfccPurchaseValue: x.actualfccPurchaseValue,
                    regionalMarketWS: x.purchaseFromECValue
                });
            }
        });
        result.forEach(x => {
            x.fccPurchaseValue = x.actualfccPurchaseValue
            x.purchaseFromECValue = x.netAmount * x.regionalMarketWS
            x.valueSaving = x.purchaseFromECValue - x.fccPurchaseValue
            x.saving = x.purchaseFromECValue == 0 ? 0 : (x.valueSaving / x.purchaseFromECValue) * 100
        })

        const netAmount = result.reduce((accumulator, current) => accumulator + current.netAmount, 0);
        const fccBuyingPrice = result.reduce((accumulator, current) => accumulator + current.fccBuyingPrice, 0);
        const regionalMarketWS = result.reduce((accumulator, current) => accumulator + current.regionalMarketWS, 0);
        const fccPurchaseValue = result.reduce((accumulator, current) => accumulator + current.fccPurchaseValue, 0);
        const purchaseFromECValue = result.reduce((accumulator, current) => accumulator + current.purchaseFromECValue, 0);
        const valueSaving = result.reduce((accumulator, current) => accumulator + current.saving, 0);

        const ytdFCCPurchasingValue = ytdDetails.fccPurchaseValue == 0 || ytdDetails.fccPurchaseValue == undefined || ytdDetails.toDateFCCPurchaseValue == 0 || ytdDetails.toDateFCCPurchaseValue == undefined || isNaN(ytdDetails.toDateFCCPurchaseValue) || isNaN(ytdDetails.fccPurchaseValue) ? 0 : (ytdDetails.toDateFCCPurchaseValue - ytdDetails.fccPurchaseValue) / ytdDetails.fccPurchaseValue;
        const ytdECPurchaseValue = ytdDetails.purchaseFromECValue == 0 || ytdDetails.purchaseFromECValue == undefined || ytdDetails.toDatepurchaseFromECValue == 0 || ytdDetails.toDatepurchaseFromECValue == undefined || isNaN(ytdDetails.toDatepurchaseFromECValue) || isNaN(ytdDetails.purchaseFromECValue) ? 0 : (ytdDetails.toDatepurchaseFromECValue - ytdDetails.purchaseFromECValue) / ytdDetails.toDatepurchaseFromECValue;

        setTotalRow({
            ...total,
            netAmount: netAmount,
            fccBuyingPrice: fccBuyingPrice,
            regionalMarketWS: regionalMarketWS,
            fccPurchaseValue: fccPurchaseValue,
            purchaseFromECValue: purchaseFromECValue,
            valueSaving: (purchaseFromECValue - fccPurchaseValue),
            saving: purchaseFromECValue !== 0 ? ((purchaseFromECValue - fccPurchaseValue) / purchaseFromECValue) * 100 : 0
        })
        setMtdDetails({
            ...mtdDetails,
            fccPurchaseValue: mtdFCCPurchaseValue,
            purchaseFromECValue: mtdPurchaseFromECValue,
            valueSaving: mtdValueSaving,
            saving: mtdSaving
        })
        setYtdDetails({
            ...ytdDetails,
            fccPurchaseValue: ytdFCCPurchaseValue,
            purchaseFromECValue: ytdPurchaseFromECValue,
            toDateFCCPurchaseValue: toDateytdFCCPurchaseValue,
            toDatepurchaseFromECValue: toDateytdPurchaseFromECValue,
            valueSaving: toDateytdFCCPurchaseValue,
            saving: ytdSaving
        })
        setnetBenefitOfFCCDetails(result.sort((a, b) => a.productName > b.productName ? 1 : -1));
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setnetBenefitOfFCCDetails([])
            // setToDate(new Date());
            setFromDate(new Date());
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: 0
            })
        } else {
            setnetBenefitOfFCCDetails([])
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            // setToDate(new Date());
            setFromDate(new Date());
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: 0
            })
        }
    }

    useEffect(() => {
        setPage(0);
        trackPromise(GetProductDetails());
        setnetBenefitOfFCCDetails([])
    }, [selectedCategoryOptions]);

    useEffect(() => {
        setPage(0);
        trackPromise(GetFactoriesByGroupID());
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
        setnetBenefitOfFCCDetails([])
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
        setnetBenefitOfFCCDetails([])
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
        setSelectedProductOptions([])
        setnetBenefitOfFCCDetails([])
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
        setnetBenefitOfFCCDetails([])
    }, [formik.values.cropID]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
        setnetBenefitOfFCCDetails([])
    }, [fromDate]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [selectedProductOptions])

    useEffect(() => {
        setPage(0);
        if (formik.values.operationEntityID != 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, formik.values.operationEntityID])

    useEffect(() => {
        if (formik.values.operationEntityID == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [formik.values.operationEntityID])

    useEffect(() => {
        setValues({
            ...values,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions
        })
    }, [selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        if (purchasePrice.length != 0) {
            calculateTotalQty()
        }
    }, [purchasePrice]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties();
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            formik.values.operationEntityID.toString(),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            setFactory(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(NetBenefitOfFCCDetails);
        var settings = {
            sheetName: 'Net Benefit Of FCC Report',
            // fileName: 'Net Benefit Of FCC Report_' + new Date(fromDate).toISOString().split('T')[0] + '-' + new Date(toDate).toISOString().split('T')[0],
            fileName: 'Net Benefit Of FCC Report_' + new Date(fromDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Net Benefit Of FCC Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(
                selectedCategoryOptions.length === productcatogery.length ? [] :
                    productcatogery.map((option) => option.value)
            );
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(
                selectedProductOptions.length === product.length ? [] :
                    product.map((option) => option.value)
            );
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => {
                var vr = {
                    'SKU': x.productName,
                    'Qty Purchase': x.netAmount == 0 ? '-' : parseFloat(x.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'FCC Buying Price (Rs)': x.fccBuyingPrice == 0 ? '-' : parseFloat(x.fccBuyingPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Regional Market WS price (Rs)': x.regionalMarketWS == 0 ? '-' : parseFloat(x.regionalMarketWS).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'FCC Purchase Value (Rs)': x.fccPurchaseValue == 0 ? '-' : parseFloat(x.fccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'If Purchased From EC Value (Rs)': x.purchaseFromECValue == 0 ? '-' : parseFloat(x.purchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Value Saving (Rs)': x.valueSaving == 0 ? '-' : parseFloat(x.valueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Saving (%)': x.purchaseFromECValue == 0 ? '-' : parseFloat(x.saving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                }
                res.push(vr);
            });
            var vr = {
                'SKU': "Total",
                'Qty Purchase': total.netAmount == 0 ? '-' : parseFloat(total.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'FCC Purchase Value (Rs)': total.fccPurchaseValue == 0 ? '-' : parseFloat(total.fccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'If Purchased From EC Value (Rs)': total.purchaseFromECValue == 0 ? '-' : parseFloat(total.purchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Value Saving (Rs)': total.valueSaving == 0 ? '-' : parseFloat(total.valueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr);
            res.push({});
            res.push({ 'SKU': "MTD FCC Purchase Value (Rs) : ", 'Qty Purchase': mtdDetails.fccPurchaseValue == 0 || mtdDetails.fccPurchaseValue == undefined ? '-' : parseFloat(mtdDetails.fccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "MTD EC Purchase Value (Rs) : ", 'Qty Purchase': mtdDetails.purchaseFromECValue == 0 || mtdDetails.purchaseFromECValue == undefined ? '-' : parseFloat(mtdDetails.purchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "YTD FCC Purchasing Value (Rs) : ", 'Qty Purchase': ytdDetails.toDateFCCPurchaseValue == 0 || ytdDetails.toDateFCCPurchaseValue == undefined ? '-' : parseFloat(ytdDetails.toDateFCCPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "YTD EC Purchase value (Rs) : ", 'Qty Purchase': ytdDetails.toDatepurchaseFromECValue == 0 || ytdDetails.toDatepurchaseFromECValue == undefined ? '-' : parseFloat(ytdDetails.toDatepurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "MTD Saving (Rs) : ", 'Qty Purchase': mtdDetails.valueSaving == undefined || mtdDetails.valueSaving == 0 || isNaN(mtdDetails.valueSaving) ? '-' : parseFloat(mtdDetails.valueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "MTD Saving (%) : ", 'Qty Purchase': mtdDetails.saving == undefined || mtdDetails.saving == 0 || isNaN(mtdDetails.saving) ? '-' : parseFloat(mtdDetails.saving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "YTD Saving (Rs) : ", 'Qty Purchase': (ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue) == 0 || ytdDetails.toDateFCCPurchaseValue == undefined || ytdDetails.toDatepurchaseFromECValue == undefined ? '-' : parseFloat(ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });
            res.push({ 'SKU': "YTD Saving (%): ", 'Qty Purchase': (ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue) == 0 || ytdDetails.toDatepurchaseFromECValue == 0 || ytdDetails.toDateFCCPurchaseValue == undefined || ytdDetails.toDatepurchaseFromECValue == undefined ? '-' : parseFloat(((ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue) / ytdDetails.toDatepurchaseFromECValue) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) });

        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        let fact = factory.find(x => x.factoryID == formik.values.operationEntityID)

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct);
        })
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups.groupName,
            operationEntity: fact.factoryName,
            cropCategory: categoryName.map(x => x).join(','),
            crop: productName.map(x => x).join(','),
            fromDate: new Date(fromDate).toISOString().split('T')[0],
            // toDate: new Date(toDate).toISOString().split('T')[0]
        });
    }

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const handleFromDateChange = (newValue) => {
        setFromDate(newValue);
        var endofMonthx = endOfMonth(new Date(newValue))
        setEndofMonth(endofMonthx);
        // setToDate(endOfMonth(new Date(endofMonthx)));
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Net Benefit Of FCC Purchases Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/NetBenefitOfFCCPurchasesReport"}
                        btname="Add"
                        pageName="Net Benefit Of FCC Purchases Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        {formik.values.operationEntityID === 0 && (
                                            <MenuItem key={0} value={0} disabled>
                                                Select Fresh Collection Center
                                            </MenuItem>
                                        )}
                                        {factory.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropCategoryID && errors.cropCategoryID && (
                                            <FormHelperText>{errors.cropCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} style={{ marginTop: '8px' }}>
                                <Grid item xs={12} sm={4}>
                                    <FormControl fullWidth error={Boolean(touched.cropID && errors.cropID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product Category "
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropID && errors.cropID && (
                                            <FormHelperText>{errors.cropID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Date *"
                                            value={fromDate}
                                            onChange={handleFromDateChange}
                                            shouldDisableDate={isFutureDateDisabled}
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Stack direction="row" spacing={2}>
                                        <Grid>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={clearAll}
                                                fullWidth
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                        <Grid>
                                            <Button
                                                type="submit"
                                                color="secondary"
                                                variant="outlined"
                                                fullWidth
                                            >
                                                Search
                                            </Button>
                                        </Grid>
                                    </Stack>
                                </Grid>
                            </Grid>
                            <br />
                            <>
                                {NetBenefitOfFCCDetails.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer className={classes.tableContainer} sx={{ maxHeight: 440 }}>
                                                        <Table size="small" aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>SKU</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Qty&nbsp;Purchase&nbsp;</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC&nbsp;Buying Price&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Regional&nbsp;Market&nbsp;WS price&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC&nbsp;Purchase Value&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>If&nbsp;Purchased&nbsp;From EC&nbsp;Value&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Value&nbsp;Saving&nbsp;(Rs)</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Saving&nbsp;(%)</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {NetBenefitOfFCCDetails.map((detail, i) => (
                                                                    <TableRow >
                                                                        <TableCell style={{ verticalAlign: 'top' }}>
                                                                            {detail.productName}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.netAmount == 0 ? '-' : parseFloat(detail.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.fccBuyingPrice == 0 ? '-' : parseFloat(detail.fccBuyingPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.regionalMarketWS == 0 ? '-' : parseFloat(detail.regionalMarketWS).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.fccPurchaseValue == 0 ? '-' : parseFloat(detail.fccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.purchaseFromECValue == 0 ? '-' : parseFloat(detail.purchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.valueSaving == 0 ? '-' : parseFloat(detail.valueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {detail.purchaseFromECValue == 0 ? '-' : parseFloat(detail.saving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'left' }}>
                                                                        Total
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.netAmount == 0 ? '-' : parseFloat(total.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {/* {total.fccBuyingPrice == 0 ? '-' : parseFloat(total.fccBuyingPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {/* {total.regionalMarketWS == 0 ? '-' : parseFloat(total.regionalMarketWS).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.fccPurchaseValue == 0 ? '-' : parseFloat(total.fccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.purchaseFromECValue == 0 ? '-' : parseFloat(total.purchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {total.valueSaving == 0 ? '-' : parseFloat(total.valueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                    <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                        {/* {total.saving == 0 ? '-' : parseFloat(total.saving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>
                                            </Card>
                                        </Stack>
                                        <br />
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> MTD FCC Purchase Value (Rs)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{mtdDetails.fccPurchaseValue == 0 || mtdDetails.fccPurchaseValue == undefined ? '-' : parseFloat(mtdDetails.fccPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> MTD EC Purchase Value (Rs)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{mtdDetails.purchaseFromECValue == 0 || mtdDetails.purchaseFromECValue == undefined ? '-' : parseFloat(mtdDetails.purchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> YTD FCC Purchasing Value (Rs)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{ytdDetails.toDateFCCPurchaseValue == 0 || ytdDetails.toDateFCCPurchaseValue == undefined ? '-' : parseFloat(ytdDetails.toDateFCCPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> YTD EC Purchase value (Rs)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{ytdDetails.toDatepurchaseFromECValue == 0 || ytdDetails.toDatepurchaseFromECValue == undefined ? '-' : parseFloat(ytdDetails.toDatepurchaseFromECValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> MTD Saving (Rs)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{mtdDetails.valueSaving == undefined || mtdDetails.valueSaving == 0 || isNaN(mtdDetails.valueSaving) ? '-' : parseFloat(mtdDetails.valueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> MTD Saving (%)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{mtdDetails.saving == undefined || mtdDetails.saving == 0 || isNaN(mtdDetails.saving) ? '-' : parseFloat(mtdDetails.saving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> YTD Saving (Rs)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{(ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue) == 0 || ytdDetails.toDateFCCPurchaseValue == undefined || ytdDetails.toDatepurchaseFromECValue == undefined ? '-' : parseFloat(ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item md={3} xs={12}>
                                                <b> YTD Saving (%)</b>
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <b>:&nbsp;{(ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue) == 0 || ytdDetails.toDatepurchaseFromECValue == 0 || ytdDetails.toDateFCCPurchaseValue == undefined || ytdDetails.toDatepurchaseFromECValue == undefined ? '-' : parseFloat(((ytdDetails.toDatepurchaseFromECValue - ytdDetails.toDateFCCPurchaseValue) / ytdDetails.toDatepurchaseFromECValue) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : <SearchNotFound searchQuery="Net Benefit Of FCC Purchases Report" />}</>
                        </Form>
                    </FormikProvider>
                    {NetBenefitOfFCCDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Net Benefit Of FCC Purchases Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    NetBenefitOfFCCDetails={NetBenefitOfFCCDetails}
                                    selectedSearchValues={selectedSearchValues}
                                    total={total}
                                    mtdDetails={mtdDetails}
                                    ytdDetails={ytdDetails}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}